<template>
  <div class="organizer-container">
    <h2 class="title">Finance info</h2>
    <p class="finance-description">Your finance info is applied only on events organized by you.</p>
    <div class="inputs">
      <text-field
        v-model.trim="form.legalName"
        label="Organizer legal name"
        :validator="vs.form.legalName"
      />
      <text-field v-model.trim="form.OIB" label="OIB" :validator="vs.form.OIB" />
      <text-field v-model.trim="form.authorizedPerson" label="Name and surname of the authorized person" :validator="vs.form.authorizedPerson" />
      <text-field v-model.trim="form.address" label="Address" :validator="vs.form.address" />
      <div style="display: flex; gap: 1rem">
        <text-field v-model.trim="form.city" label="City" :validator="vs.form.city" />
        <text-field v-model.trim="form.postalCode" label="Postal Code" :validator="vs.form.postalCode" />
      </div>
      <text-field v-model.trim="form.IBAN" label="IBAN" :validator="vs.form.IBAN" />
      <text-field v-model.trim="form.primaryEmail" label="Organizer primary email*" :validator="vs.form.primaryEmail" />
      <text-field v-model.trim="form.contactNumber" label="Phone number*" placeholder="+385 91 2345 678" :validator="vs.form.contactNumber"/>
      <div class="radio-buttons">
        <p class="vat-text">U sustavu PDV-a</p>
        <div class="radio-item">
          <input
            id="no"
            v-model="form.VATObligor"
            type="radio"
            :validator="vs.form.VATObligor"
            :value="false"
          />
          <label for="no">Ne</label>
        </div>
        <div class="radio-item">
          <input
            id="yes"
            v-model="form.VATObligor"
            :validator="vs.form.VATObligor"
            type="radio"
            :value="true"
          />
          <label for="yes">Da</label>
        </div>
      </div>
      <div class="note">*Please note: The information provided will be used solely for the purpose of contacting you by CoreEvent.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'organization-finance-info-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.organizer-container {
  display: flex;
  flex-direction: column;
}
.title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
.vat-text {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  color: #333333;
}
.radio-item {
  display: inline-block;
  position: relative;
  padding: 0 0.375rem;
  margin: 0.625rem 0 0;
}
.radio-item input[type='radio'] {
  display: none;
}
.radio-item label {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  color: #979797;
}
.radio-item label:before {
  content: ' ';
  display: inline-block;
  position: relative;
  top: 0.313rem;
  margin: 0 0.313rem 0 0;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 0.688rem;
  border: 0.125rem solid #666666;
  background-color: transparent;
}
.radio-item input[type='radio']:checked + label:after {
  border-radius: 0.688rem;
  width: 0.75rem;
  height: 0.75rem;
  position: absolute;
  top: 0.563rem;
  left: 0.625rem;
  content: ' ';
  display: block;
  background: #0277bd;
}
.inputs {
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
}
.finance-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #979797;
}
.note {
  color: #979797;
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
</style>
